export const headers = {
    "Content-Type": "application/json",
}

const tosin = localStorage.getItem("token")
export const hashKey = {
    token: tosin,
}

